export default __webpack_public_path__ + "static/media/HeelOff.52289fa7.png";